import { MenuAlt2Icon } from '@heroicons/react/outline';
import { useSelector } from 'react-redux';
import { accountSelector } from '../../../store';

export default function SidebarNavHeader({
  isFullNavHidden,
  navToggleHandler,
}: {
  isFullNavHidden?: boolean;
  navToggleHandler?: () => void;
}) {
  const { data: currentClientAccount } = useSelector(accountSelector);

  return (
    <>
      {!isFullNavHidden && (
        <>
          {currentClientAccount?.companyLogoUrl && (
            <div className='flex items-center px-6 h-12 w-2/3'>
              <img
                src={currentClientAccount?.companyLogoUrl}
                alt='logo'
                className='object-fit h-full w-full'
              />
            </div>
          )}
          {!currentClientAccount?.companyLogoUrl && (
            <div className='flex items-center h-16 px-6 w-full'>
              <img
                className='h-10 w-auto object-fit'
                src='https://assets.seinterminal.com/images/logos/SEIN_Tech_Partners_Logo_Color.png'
                alt='sein technology partners logo'
              />
            </div>
          )}
        </>
      )}
      {isFullNavHidden && (
        <span
          className='flex text-center justify-center items-center w-full'
          onClick={navToggleHandler}
        >
          {isFullNavHidden && (
            <MenuAlt2Icon className='h-8 w-8 hover:text-primaryColor-normal cursor-pointer transition duration-300' />
          )}
        </span>
      )}
    </>
  );
}
